import { getConfig } from "@cirrus/config"
import { routeTemplates } from "@cirrus-delivery/v1/router"

require("@cirrus/legacy/vendor-bower/js-url/url")

$(document).ready(function () {
  sessionStorage.clear()
  sessionStorage.setItem("Cirrus_Delivery_Mode", "Anonymous")

  const sessionToken = url("?session")

  $.post(Url.api(`/api/v1/delivery/anonymous/session/start-new/${sessionToken}`))
    .done((response) => {
      sessionStorage.setItem(getConfig().TokenKey, response.accessToken)
      $.ajaxSetup({
        headers: { Authorization: "Bearer " + response.accessToken },
      })

      window.location.replace(
        Url.get("~/app#" + routeTemplates.anonymousStart.build(response.scheduleId)),
      )
    })
    .fail((response) => {
      $(".facebookContainer").hide()

      if (response && response.status === 400) {
        $(".ext-login_error").text(
          "Exam is not ready. Please contact the administrator for assistance.",
        )
      } else if (response && response.status === 401) {
        $(".ext-login_error").text(
          "Unfortunately this page is no longer available. Please contact the administrator for assistance.",
        )
      } else if (response && response.status === 404) {
        $(".ext-login_error").text(
          "Session token not found. Please contact the administrator for assistance.",
        )
      } else if (response && response.status === 429) {
        $(".ext-login_error").text(
          "Allowed number of attempts exceeded. Please contact the administrator for assistance.",
        )
      } else {
        $(".ext-login_error").text(
          "Unfortunately this page is no longer available. Please contact the administrator for assistance.",
        )
      }

      $(".errorsContainer").show()
    })
})
